import { Component, Input, OnInit, ViewChild } from "@angular/core";
import {
  AbstractControl,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import { IonContent, Platform } from "@ionic/angular";
import { UserSessionService } from "src/app/services/user-session/user-session.service";
import { Navigator } from "src/app/services/routing/navigator";
import { RafService } from "src/app/services/raf/raf.service";
import { SuccessMessageService } from "src/app/services/message-provider/success-message.service";
import { Clipboard } from "@capacitor/clipboard";
import { NAME_PATTERN, EMAIL_PATTERN_V2 } from "src/app/services/customFormValidators";

@Component({
  selector: "app-raf-invite-email",
  templateUrl: "./raf-invite-email.component.html",
  styleUrls: ["./raf-invite-email.component.scss"],
})
export class RafInviteEmailComponent implements OnInit {
  @ViewChild(IonContent) content: IonContent;
  @Input() source: string;

  public inviteForm: FormGroup;
  public friendName: AbstractControl;
  public friendEmail: AbstractControl;
  clientError: string;

  public error: any = null;

  public code: string = "";
  public copyText: any;

  public arrFriendNames: string[] = [];
  public arrFriendEmails: string[] = [];
  public strFriendsToEmail: string = "";
  public strResponse;
  public strResponseAlreadySent;
  public strResponseRegistered;
  public hideBackButtonInNav = false;
  public response;
  public showError: boolean = false;
  public showSuccess: boolean = false;

  constructor(
    private userSessionService: UserSessionService,
    protected platform: Platform,
    private navigator: Navigator,
    private rafService: RafService,
    public successMessageService: SuccessMessageService,
  ) {
    this.rafService.callGetReferrerCode().subscribe(
      (response: any) => {
        if (response && !!response.result) {
          this.code = response.payload.code;
        }
      }
    );
  }

  ngOnInit() {
    if (this.source == 'promotions') {
      this.hideBackButtonInNav = true;
    } else {
      this.hideBackButtonInNav = false;
    }
    this.clientError = "";
    this.inviteForm = new FormGroup({
      friendName: new FormControl("", [Validators.required, Validators.pattern(NAME_PATTERN)]),
      friendEmail: new FormControl("", [
        Validators.required,
        Validators.pattern(EMAIL_PATTERN_V2)
      ]),
    });

    this.friendName = this.inviteForm.get("friendName");
    this.friendEmail = this.inviteForm.get("friendEmail");
  }

  ionViewDidEnter() {
    this.successMessageService.clearMessage();
    this.copyText = document.getElementById("refCodeCopy");
  }

  ionViewWillLeave() {
    this.showError = false;
    this.showSuccess = false;
  }

  onCopyCode() {
    const element = this.copyText;
    element.select();
    if (this.platform.is("ios") && !this.platform.is("capacitor")) {
      element.focus();
      element.setSelectionRange(0, 999);
      document.execCommand("Copy");
    } else if (this.platform.is("capacitor")) {
      if (this.platform.is("ios")) {
        element.focus();
        element.setSelectionRange(0, 999);
      }
      Clipboard.write({
        string: element.value,
      }).then(() => {
        console.log("Clipboard Copy Complete!", element.value);
      });
    } else {
      navigator.clipboard.writeText(element.value);
    }
  }

  onAdd() {
    this.error = null;
    this.showError = false;
    this.showSuccess = false;
    this.clientError = "";
    const fname: string = this.friendName.value;
    const femail: string = this.friendEmail.value;

    if (this.strFriendsToEmail.indexOf(femail) > -1) {
      this.clientError = "Ooops, That email is already in your list!";
      this.content.scrollToTop();
    } else {
      this.arrFriendNames.push(fname);
      this.arrFriendEmails.push(femail);

      this.friendName.setValue("");
      this.friendEmail.setValue("");

      this.friendName.markAsPristine();
      this.friendEmail.markAsPristine();
      this.friendName.markAsUntouched();
      this.friendEmail.markAsUntouched();

      this.buildFriendsList();
    }
  }

  onRemove(event) {

    this.showError = false;
    this.showSuccess = false;

    this.arrFriendNames.pop();
    this.arrFriendEmails.pop();

    this.buildFriendsList();

    event.preventDefault();
  }

  buildFriendsList() {
    this.strFriendsToEmail = "";

    let fname: string;
    let femail: string;

    for (let i: number = 0; i < this.arrFriendEmails.length; i++) {
      fname = this.arrFriendNames[i];
      femail = this.arrFriendEmails[i];

      if (i == 0) {
        this.strFriendsToEmail += "[" + fname + "] " + femail;
      } else {
        this.strFriendsToEmail += ", [" + fname + "] " + femail;
      }
    }
  }

  onSendEmails() {
    this.showError = false;
    this.showSuccess = false;

    this.response = {};
    this.successMessageService.clearMessage();
    this.rafService
      .callInviteFriends(
        this.arrFriendNames.join(","),
        this.arrFriendEmails.join(","),
        this.code
      )
      .subscribe({
        next: (response: any) => {
          if (response && !!response.result) {
            this.response = response;
            this.arrFriendNames = [];
            this.arrFriendEmails = [];
            this.strFriendsToEmail = "";
            console.log("test ", response);
            if (response.payload.sent.length > 0) {
              const emailsSent = response.payload.sent.join(", ");
              this.strResponse = `We successfully sent out ${response.payload.sent.length} invitation(s) to ${emailsSent}.`;
              this.showSuccess = true;
              this.successMessageService.setMessage(this.strResponse);
            }

            if (response.payload.already_sent.length > 0) {
              const emailsAlreadySent = response.payload.already_sent.join(", ");
              this.showSuccess = true;
              this.strResponseAlreadySent = `We already sent out an invitation to ${emailsAlreadySent}  on your behalf.`;
            }

            if (response.payload.already_registered.length > 0) {
              const emailsAlreadyRegistered = response.payload.already_registered.join(", ");
              this.showError = true;
              this.strResponseRegistered = `Oops, ${emailsAlreadyRegistered} is already registered and can't be invited.`;
            }

            this.content.scrollToTop();
            this.userSessionService.refreshCustomer();
          }
        },
        error: (error) => {
          error.setErrorMessage("There was an issue emailing your friends.");

          this.error = error;
          this.content.scrollToTop();
        }
    });
  }
}
